import {createFileRoute} from '@tanstack/react-router';

import {ServiceTypesPage} from '@/modules/admin-settings/pages/ServiceTypesPage';

export const Route = createFileRoute('/_authenticated/admin/settings/service-types/')({
  component: ServiceTypesPage,
});
